"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserPreferencesProvider = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _rcPreferences = require("../../state/entities/rcPreferences");
const BrowserPreferencesProvider = _ref => {
  let {
    children
  } = _ref;
  const dispatch = (0, _reactRedux.useDispatch)();
  const locale = (0, _reactRedux.useSelector)(_rcPreferences.rcPreferencesSelectors.locale);
  (0, _react.useEffect)(() => {
    if (locale) {
      return;
    }
    dispatch(_rcPreferences.rcPreferencesActions.infer());
  }, [locale]);
  return children;
};
exports.BrowserPreferencesProvider = BrowserPreferencesProvider;